import { AxiosResponse, isAxiosError } from 'axios';
import createAxiosInstance from '../middlewares/axios.interceptors';

const birthdaysUrl = '/aniversarios';

export const BirthdaysService = {
  getBirthdays: async () => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(birthdaysUrl + '/list');
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  }
};
